<template>
  <div id="app" v-on:scroll="handleScroll">
    <div
      class="menuCard"
      ref="menu"
      @mouseover="goToAnnounce()"
      @mouseleave="goToAnLeave()"
    >
      <div class="el-menu-i">
        <div class="logo" @mouseover="removeOver()">
          <a @click="$router.push('/dashboard')"
            ><img :src="logoPng" width="202"
          /></a>
        </div>
        <div class="menuItem">
          <div @mouseover="removeOver()">
            <router-link to="/dashboard" tag="div" class="router">
              <span ref="router1" :style="{ color: textColor }">首页</span>
            </router-link>
          </div>
          <div class="product" @mouseover="productOver()">
            <router-link to="/products" tag="div" class="router">
              <span class="router" :style="{ color: textColor }" ref="router2"
                >产品</span
              >
              <i
                class="icon el-icon-arrow-down"
                :style="{ color: textColor }"
              ></i>
            </router-link>

            <div
              class="productList"
              v-show="productFlag"
              @mouseleave="productLeave()"
            >
              <div class="productLeft">
                <div class="leftItem1" @click="$router.push('/products')">
                  <div>
                    <img :src="Image.system" alt="">
                    <span style="color: #e02d36">产品体系</span>
                  </div>
                  <img :src="Image.arrow" class="arrow" alt="">
                </div>
                <div
                  class="leftItem"
                  v-for="(item, index) in productData"
                  :key="index"
                  @click="leftClick(item)"
                >
                  <img :src="item.img1" alt="" v-if="!item.flag" />
                  <img :src="item.img2" alt="" v-else />
                  <span
                    v-if="!item.flag"
                    style="color: #21373d"
                    @mouseover="productItemOver(item)"
                    >{{ item.leftTitle }}</span
                  >
                  <span
                    v-else
                    style="color: #e02d36"
                    @mouseover="productItemOver(item)"
                    >{{ item.leftTitle }}</span
                  >
                </div>
              </div>
              <div class="productRight">
                <h2>{{ productList.rightTitle }}</h2>
                <div>
                  <div
                    v-for="(val, indexs) in productList.children"
                    :key="indexs"
                  >
                    <div class="rightTitle">{{ val.title }}</div>
                    <div v-for="(va, ind) in val.children" :key="ind">
                      <p
                        @click="toProductsInfo(va)"
                        :class="[
                          activeProduct == va.productsId ? 'is-active' : '',
                        ]"
                      >
                        {{ va.label }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="programme" @mouseover="programmeOver()">
            <span class="router" :style="{ color: textColor }" ref="router3"
              >解决方案</span
            >
            <i
              class="icon el-icon-arrow-down"
              :style="{ color: textColor }"
            ></i>
            <div
              class="programmeList"
              v-show="programmeFlag"
              @mouseleave="programmeLeave()"
            >
              <div
                v-for="item in programmeData"
                :key="item.id"
                @click="pushPath(item)"
                :class="item.className"
              >
                <p>{{ item.title }}</p>
                <img :src="item.img" />
                <p>{{ item.content }}</p>
              </div>
            </div>
          </div>
          <div @mouseover="removeOver()">
            <router-link to="/we" tag="div" class="router">
              <span ref="router4" :style="{ color: textColor }">关于我们</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="body_content" ref="body_content">
      <transition name="fade">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
    <footerVue></footerVue>
  </div>
</template>
<script>
import routers from "@/router";
import footerVue from "@/views/footer";
import images from "@/utils/js/exportImage";
export default {
  data() {
    return {
      Image: images,
      activeIndex: "/dashboard",
      path: "",
      routers: [],
      logoPng: images.rhzz_logo,
      textColor: "#fff",
      productFlag: false,
      programmeFlag: false ,
      productData: [
        {
          img1: images.item_rf,
          img2: images.item_rf1,
          leftTitle: "睿防 Rifens",
          flag: true,
          rightTitle: "数据安全产品",
          children: [
            {
              title: "识别评估",
              children: [
                {
                  type: "Rifens",
                  label: "数据安全风险评估系统",
                  productsId: 0,
                },
                { type: "Rifens", label: "数据安全治理系统", productsId: 1 },
              ],
            },
            {
              title: "监测审计",
              children: [
                { type: "Rifens", label: "数据库安全审计系统", productsId: 2 },
              ],
            },
            {
              title: "共享防护",
              children: [
                { type: "Rifens", label: "数据库透明加密系统", productsId: 3 },
                { type: "Rifens", label: "数据传输加密系统", productsId: 4 },
                { type: "Rifens", label: "数据静态脱敏系统", productsId: 5 },
                { type: "Rifens", label: "主机安全管控代理", productsId: 6 },
              ],
            },
            {
              title: "运营管理",
              children: [
                { type: "Rifens", label: "数据安全运维系统", productsId: 7 },
                // { type: "Rifens", label: "数据中台", productsId: 8 },
                // { type: "Rifens", label: "数据安全管控平台", productsId: 9 },
              ],
            },
          ],
        },
        {
          img1: images.item_rx,
          img2: images.item_rx1,
          leftTitle: "睿巡 Rinspector",
          flag: false,
          rightTitle: "边界安全产品",
          children: [
            {
              title: "边界防护",
              children: [
                { type: "Rinspector", label: "5G安全接入网关", productsId: 10 },
              ],
            },
            {
              title: "边界加固",
              children: [
                {
                  type: "Rinspector",
                  label: "网络边界安全巡逻系统",
                  productsId: 11,
                },
              ],
            },
          ],
        },
        {
          img1: images.item_rc,
          img2: images.item_rc1,
          leftTitle: "睿察 Ritect",
          flag: false,
          rightTitle: "工控安全产品",
          children: [
            {
              title: "网络监测",
              children: [
                {
                  type: "Ritect",
                  label: "工业网络异常监测系统",
                  productsId: 12,
                },
              ],
            },
            {
              title: "网络审计",
              children: [
                {
                  type: "Ritect",
                  label: "工业安全综合审计系统",
                  productsId: 13,
                },
              ],
            },
          ],
        },
        {
          img1: images.item_rz,
          img2: images.item_rz1,
          leftTitle: "睿知 Rilize",
          flag: false,
          rightTitle: "管理平台产品",
          children: [
            {
              title: "管理平台",
              children: [
                {
                  type: "Rilize",
                  label: "工业互联网监测与态势感知平台",
                  productsId: 14,
                },
              ],
            },
          ],
        },
        {
          img1: images.item_rs,
          img2: images.item_rs1,
          leftTitle: "睿训 Rehearsal",
          flag: false,
          rightTitle: "培训演练产品",
          children: [
            {
              title: "培训演练",
              children: [
                {
                  type: "Rehearsal",
                  label: "工业互联网安全实训平台",
                  productsId: 15,
                },
              ],
            },
          ],
        },
      ],
      productList: {
        rightTitle: "数据安全产品",
        children: [
          {
            title: "识别评估",
            children: [
              {
                type: "Rifens",
                label: "数据安全风险评估系统",
                productsId: 0,
              },
              { type: "Rifens", label: "数据安全治理系统", productsId: 1 },
            ],
          },
          {
            title: "监测审计",
            children: [
              { type: "Rifens", label: "数据库安全审计系统", productsId: 2 },
            ],
          },
          {
            title: "共享防护",
            children: [
              { type: "Rifens", label: "数据库透明加密系统", productsId: 3 },
              { type: "Rifens", label: "数据传输加密系统", productsId: 4 },
              { type: "Rifens", label: "数据静态脱敏系统", productsId: 5 },
              { type: "Rifens", label: "主机安全管控代理", productsId:6 },
            ],
          },
          {
            title: "运营管理",
            children: [
              { type: "Rifens", label: "数据安全运维系统", productsId: 7 },
              // { type: "Rifens", label: "数据中台", productsId: 8 },
              // { type: "Rifens", label: "数据安全管控平台", productsId: 9 },
            ],
          },
        ],
      },
      programmeData: [
        {
          title: "电力行业解决方案",
          className: "",
          img: images.programme_item1,
          content: "国家电网一体化安全防护方案",
          path: "/solution/electric",
        },
        {
          title: "电信行业解决方案",
          className: "",
          img: images.programme_item2,
          content: "5G+工业互联网+物联网安全解决方案",
          path: "/solution/telecom",
        },
        {
          title: "关键制造行业解决方案",
          className: "",
          img: images.programme_item3,
          content: "工业互联网监测与态势感知平台",
          path: "/solution/pivotal",
        },
        {
          title: "教育行业解决方案",
          className: "",
          img: images.programme_item4,
          content: "智慧校园信息安全解决方案",
          path: "/solution/campus",
        },
      ],
    };
  },
  components: {
    footerVue,
  },
  watch: {
    "$route.path"(newVal, oldVal) {
      /**
       * 监听路由地址，判断当前选择的菜单，并增加相关选中样式
       * 当路由菜单存在子菜单时，将所有子菜单维护成一个数组，
       *
       */
      var arr = [
        {
          id: 1,
          path: "/dashboard",
        },
        {
          id: 2,
          path: "/products_info",
        },
        {
          id: 3,
          path: [
            "/solution/electric",
            "/solution/telecom",
            "/solution/pivotal",
            "/solution/campus",
          ],
        },
        {
          id: 4,
          path: "/we",
        },
      ];
      var valArr = newVal.split("/");
      arr.forEach((val, i) => {
        var refRoute = eval("this.$refs.router" + val.id);
        if (valArr.length > 2) {
          var num = val.path.indexOf(newVal);
          if (num > -1) {
            refRoute.className = "router is-active";
          } else {
            refRoute.className = "router";
          }
        } else {
          this.programmeData.forEach((val, i) => {
            val.className = "";
          });
          this.productData.forEach((val, i) => {
            val.flag = false;
            this.productData[0].flag = true;
          });

          if (newVal == val.path) {
            refRoute.className = "router is-active";
          } else {
            refRoute.className = "router";
          }
        }
      });
      if (this.$route.path == "/products") {
        this.$refs.router2.className = "router is-active";
      }
      if (this.$route.path != "/dashboard" && this.$route.path != "/we") {
        var menu = this.$refs.menu;
        menu.style.backgroundColor = "#ffffff";
        menu.style.boxShadow = "0px 4px 16px 1px rgba(0,0,0,0.08)";
        this.logoPng = images.rhzz_logo1;
        this.textColor = "#000";
      }
    },
    "$route.query": {
      handler(val) {
        if (val.type) {
          this.productData.forEach((item) => {
            if (item.leftTitle.indexOf(val.type) > -1) {
              item.flag = true;
              this.productList = {
                rightTitle: item.rightTitle,
                children: item.children,
              };
            } else {
              item.flag = false;
            }
          });
        } else {
          this.productData[0].flag = true;
          this.productList = {
            rightTitle: this.productData[0].rightTitle,
            children: this.productData[0].children,
          };
        }
      },
      immediate: true,
    },
  },
  computed: {
    activeProduct() {
      return this.$route.query.productsId;
    },
  },
  methods: {
    pushPath(item) {
      this.programmeData.forEach((val, i) => {
        if (item.title == val.title) {
          val.className = "programme-active";
        } else {
          val.className = "";
        }
      });
      this.$router.push(item.path).catch((err) => err);
    },
    //跳转进入产品详情(高亮....)
    toProductsInfo(obj) {
      if (this.activeProduct == obj.productsId) return false;
      this.$router.push({
        path: "/products_info",
        query: {
          type: obj.type,
          productsId: obj.productsId,
        },
      });
    },
    // 滑入事件
    goToAnnounce() {
      if (this.$route.path == "/dashboard" || this.$route.path == "/we") {
        var menu = this.$refs.menu;
        menu.style.backgroundColor = "#ffffff";
        this.logoPng = images.rhzz_logo1;
        this.textColor = "#000";
      }
    },
    // 滑出事件
    goToAnLeave() {
      if (this.$route.path == "/dashboard" || this.$route.path == "/we") {
        var body_content = document.documentElement.scrollTop;
        var menu = this.$refs.menu;
        if (body_content >= 428) {
          menu.style.backgroundColor = "#ffffff";
          this.logoPng = images.rhzz_logo1;
          this.textColor = "#000";
        } else {
          menu.style.backgroundColor = "transparent";
          this.logoPng = images.rhzz_logo;
          this.textColor = "#fff";
        }
      }
    },
    // 产品滑入
    productOver() {
      this.productFlag = true;
      this.programmeFlag = false;
    },
    productItemOver(item) {
      this.productData.forEach((val, i) => {
        val.flag = false;
      });
      item.flag = true;
      this.productList = {
        rightTitle: item.rightTitle,
        children: item.children,
      };
    },
    // 产品滑出
    productLeave() {
      this.productFlag = false;
    },
    // 解决方案滑入
    programmeOver() {
      this.programmeFlag = true;
      this.productFlag = false;
    },
    // 解决方案滑出
    programmeLeave() {
      this.programmeFlag = false;
    },
    // 其余菜单划入
    removeOver() {
      this.programmeFlag = false;
      this.productFlag = false;
    },
    // 左侧产品点击事件
    leftClick(item) {
      this.productData.forEach((val, i) => {
        val.flag = false;
      });
      item.flag = true;
      this.productList = {
        rightTitle: item.rightTitle,
        children: item.children,
      };
    },
    textCall(item) {
      var arr = document.querySelectorAll(".router");
      arr.forEach((val, i) => {
        if (i == item) {
          val.className = "router is-active";
        } else {
          val.className = "router";
        }
      });
    },
    handleScroll() {
      if (this.$route.path == "/dashboard" || this.$route.path == "/we") {
        var body_content = document.documentElement.scrollTop;
        var menu = this.$refs.menu;
        if (body_content >= 328) {
          menu.style.backgroundColor = "#ffffff";
          menu.style.boxShadow = "0px 4px 16px 1px rgba(0,0,0,0.08)";
          this.logoPng = images.rhzz_logo1;
          this.textColor = "#000";
        } else {
          menu.style.backgroundColor = "transparent";
          menu.style.boxShadow = "0px 4px 16px 1px transparent";
          this.logoPng = images.rhzz_logo;
          this.textColor = "#fff";
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.routers = routers.options.routes;
  },
};
</script>
<style lang="scss" scoped>
.leftItem1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  div {
    display: flex;
  }
  img {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    color: #21373d;
  }
  .arrow {
    margin-right: 30px;
  }
}
@media (max-width: 1441px) {
  .menuCard {
    width: 100%;
    max-width: 1440px;
    height: 90px;
    margin: 0;
    position: fixed;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    transition: background;
    transition-duration: 1s;
    z-index: 102;
  }

  .el-menu-i {
    display: flex;
    margin: 0 auto;
    align-items: center;
    width: 100%;
    max-width: 1440px;
    height: 90px;
    transition: background;
    transition-duration: 1s;
    cursor: pointer;
    .logo {
      margin-left: 120px;
      margin-right: 100px;
    }
    .menuItem {
      width: 430px;
      display: flex;
      justify-content: space-around;
      .router {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      i {
        padding-left: 4px;
        color: #fff;
      }
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0px solid !important;
  }
  .product {
    position: relative;
  }
  .productList {
    position: absolute;
    left: -510px;
    top: 56px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.16);
    max-width: 1440px;
    min-width: 1020px;
    width: 96vw;
    height: 340px;
    z-index: 1040;
    overflow: hidden;
    .productLeft {
      width: 20%;
      padding-top: 50px;
      padding-left: 96px;
      float: left;
      border-right: 1px solid #d9d9d9;
      .leftItem {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        img {
          display: block;
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #21373d;
        }
      }
    }
    .productRight {
      padding-left: 60px;
      width: 80%;
      float: left;
      h2 {
        margin-bottom: 13px;
        margin-top: 36px;
        font-size: 20px;
        font-weight: 500;
        color: #21373d;
      }
      > div {
        display: flex;
        > div {
          width: 200px;
          margin-right: 60px;

          .rightTitle {
            padding-bottom: 8px;
            border-bottom: 1px solid #d9d9d9;
            margin-bottom: 30px;
            font-size: 14px;
            font-weight: 500;
            color: #74787a;
          }
          > div {
            p {
              margin-bottom: 34px;
              font-size: 16px;
              font-weight: 700;
              color: #21373d;
              &:hover {
                color: #e02d36;
              }
            }
          }
        }
      }
    }
  }
  .is-active {
    color: rgba(224, 45, 54, 1) !important;
  }
  .programme {
    position: relative;
    .programmeList {
      position: absolute;
      left: -612px;
      top: 56px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.16);
      width: 96vw;
      max-width: 1440px;
      min-width: 1020px;
      height: 240px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      z-index: 1040;
      p:first-child {
        font-size: 14px;
        font-weight: 500;
        color: #74787a;
        margin-bottom: 8px;
      }
      img {
        display: block;
        width: 160px;
        height: 60px;
        margin-bottom: 16px;
      }
      p:last-child {
        font-size: 16px;
        font-weight: bold;
        color: #21373d;
      }
      p:last-child:hover {
        color: #e02d36;
      }
    }
    .programme-active {
      p:last-child {
        color: #e02d36;
      }
    }
  }
}
@media (min-width: 1441px) {
  .menuCard {
    width: 100%;
    max-width: 1920px;
    height: 90px;
    margin: 0;
    position: fixed;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    transition: background;
    transition-duration: 1s;
    z-index: 102;
  }

  .el-menu-i {
    display: flex;
    margin: 0 auto;
    align-items: center;
    width: 1440px;
    height: 90px;
    transition: background;
    transition-duration: 1s;
    cursor: pointer;
    .logo {
      margin-left: 120px;
      margin-right: 100px;
    }
    .menuItem {
      width: 430px;
      display: flex;
      justify-content: space-around;
      .router {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      i {
        padding-left: 4px;
        color: #fff;
      }
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0px solid !important;
  }
  .product {
    position: relative;
  }
  .productList {
    position: absolute;
    left: -510px;
    top: 56px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.16);
    width: 100%;
    max-width: 1920px;
    min-width: 1420px;
    height: 340px;
    z-index: 1040;
    overflow: hidden;
    .productLeft {
      width: 300px;
      padding-top: 50px;
      padding-left: 96px;
      float: left;
      border-right: 1px solid #d9d9d9;
      .leftItem {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        img {
          display: block;
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #21373d;
        }
      }
    }
    .productRight {
      padding-left: 60px;
      width: 1100px;
      float: left;
      h2 {
        margin-bottom: 13px;
        margin-top: 36px;
        font-size: 20px;
        font-weight: 500;
        color: #21373d;
      }
      > div {
        display: flex;
        > div {
          width: 200px;
          margin-right: 60px;

          .rightTitle {
            padding-bottom: 8px;
            border-bottom: 1px solid #d9d9d9;
            margin-bottom: 30px;
            font-size: 14px;
            font-weight: 500;
            color: #74787a;
          }
          > div {
            p {
              margin-bottom: 34px;
              font-size: 16px;
              font-weight: 700;
              color: #21373d;
              &:hover {
                color: #e02d36;
              }
            }
          }
        }
      }
    }
  }
  .is-active {
    color: rgba(224, 45, 54, 1) !important;
  }
  .programme {
    position: relative;
    .programmeList {
      position: absolute;
      left: -612px;
      top: 56px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.16);
      width: 100%;
      max-width: 1920px;
      min-width: 1420px;
      height: 240px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      z-index: 1040;
      p:first-child {
        font-size: 14px;
        font-weight: 500;
        color: #74787a;
        margin-bottom: 8px;
      }
      img {
        display: block;
        width: 160px;
        height: 60px;
        margin-bottom: 16px;
      }
      p:last-child {
        font-size: 16px;
        font-weight: bold;
        color: #21373d;
      }
      p:last-child:hover {
        color: #e02d36;
      }
    }
    .programme-active {
      p:last-child {
        color: #e02d36;
      }
    }
  }
}
</style>
